export default function formattingJson(markdown, ebook = false) {
  const regexParagraph = /(?: *\r| *\n){3,}|\r *\r|\n *\n|\r +\n/g
  const regexLine = /\r\n|\r|\n/g

  const regexURL = /(?<=^| )(http[s]*:\/\/[^ ]+)/g
  const regexBold = /\*([^*]+)\*/g
  const regexList = /^- +(.+)/
  const regexH3 = /^# +(.+)/
  const regexImageEbook = /\[image\]https:\/\/thegoodmanager.eu\/wordpress\/wp-content\/uploads\/([^ ]+)\[\/image\]/g
  const regexImage = /\[image\]([^ ]+)\[\/image\]/g
  const regexAudio = /\[audio\]([^ ]+)\[\/audio\]/g
  const regexYoutube = /\[youtube\]https:\/\/www.youtube.com\/watch\?v=([^ ]+)\[\/youtube\]/g
  const regexCanva = /\[canva\]https:\/\/www.canva.com\/design\/([^ ]+)\/view\[\/canva\]/g
  const regexVideo = /\[video\]([^ ]+)\[\/video\]/g

  const regexListStart = /(?<!<\/li>)(<li>)/g
  const regexListEnd = /(<\/li>)(?!<li>)/g
  const regexEmptyParagraph = /(<p>(?:<br\/*>)*<\/p>)/g
  const regexUselessLinebreak = /<br\/*>(<\/p>)/g

  let HTML = [];

  markdown.split(regexParagraph).forEach(paragraph => {

    // Populate array with paragraph opening tag
    HTML.push('<p>')
    
    paragraph.split(regexLine).forEach(line => {

      // Remove spaces from both sides of line
      line = line.trim()

      // Check if line is not empty
      if (line !== '') {

        // Replace markdown with HTML
        line = line.replace(regexURL,  '<a href="$1" target="_blank">$1</a>')
        line = line.replace(regexBold, '<strong>$1</strong>')
        line = line.replace(regexList, '<li>$1</li>')
        line = line.replace(regexH3,   '</p><h3>$1</h3><p>')
        
        if (ebook) {
          line = line.replace(regexImageEbook, '</p><img alt="All media on this site are described by the text nearby" src="../Images/$1" /><p>')
          line = line.replace(regexImage,      '<a href="$1" target="_blank">$1</a>')
          line = line.replace(regexAudio,      '<a href="$1" target="_blank">$1</a>')
          line = line.replace(regexYoutube,    '<a href="https://www.youtube.com/watch?v=$1" target="_blank">https://www.youtube.com/watch?v=$1</a>')
          line = line.replace(regexCanva,      '<a href="https://www.canva.com/design/$1/view" target="_blank">https://www.canva.com/design/$1/view</a>')
          line = line.replace(regexVideo,      '<a href="$1" target="_blank">$1</a>')
        } else {
          line = line.replace(regexImage,   '</p><a class="image-link" href="$1" target="_blank"><img alt="All media on this site are described by the text nearby" src="$1" /></a><p>')
          line = line.replace(regexAudio,   '</p><audio controls><source src="$1"> Your browser does not support the audio element.</audio><p>')
          line = line.replace(regexYoutube, '</p><div class="embeded-video"><iframe src="https://www.youtube.com/embed/$1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div><p>')
          line = line.replace(regexCanva,   '</p><div style="position: relative; width: 100%; height: 0; padding-top: 100.0000%; padding-bottom: 48px; box-shadow: 0 2px 8px 0 rgba(63,69,81,0.16); margin-top: 1.6em; margin-bottom: 0.9em; overflow: hidden; border-radius: 8px; will-change: transform;"><iframe loading="lazy" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0;margin: 0;" src="https://www.canva.com/design/$1/view?embed"></iframe></div><p>')
          line = line.replace(regexVideo,   '</p><div class="embeded-video"><video controls><source src="$1"> Your browser does not support the video element.</video></div><p>')
        }

        // Add linebreak tag
        if (line !== '' && !line.endsWith('</li>') && !line.endsWith('<p>')) {
          line = line+(ebook? '<br/>': '<br>')
        }
        
        // Populate array with modified line
        HTML.push(line)
      }
    })

    // Populate array with paragraph closing tag
    HTML.push('</p>')
  })

  // Convert array to string
  HTML = HTML.join('')

  // Encapsulate list items with unordered list tag
  HTML = HTML.replace(regexListStart, '</p><ul>$1')
  HTML = HTML.replace(regexListEnd, '$1</ul><p>')

  // Remove empty paragraphs
  HTML = HTML.replace(regexEmptyParagraph, '')

  // Remove useless linebreaks
  HTML = HTML.replace(regexUselessLinebreak, '$1')

  return HTML;
}
